module.exports = __webpack_public_path__ + "img/savings-providers.f2765d4.png";